import React from 'react'
import ReactDOM from 'react-dom/client'
import { RecoilRoot } from 'recoil'
import { ConfigProvider, theme } from 'antd'
import { RouterProvider } from 'react-router-dom'
import 'antd/dist/reset.css'

import './usecases/configAxiosInterceptor'
import reportWebVitals from './reportWebVitals'
import './style/index.css'
import router from './router'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <RecoilRoot>
      <ConfigProvider
        theme={{
          algorithm: theme.darkAlgorithm,
          token: {
            colorBgContainer: '#0C1C33',
            colorPrimary: '#00D4FF'
          }
        }}
      >
        <RouterProvider router={router} />
      </ConfigProvider>
    </RecoilRoot>
  </React.StrictMode>
)

reportWebVitals()
